export default __webpack_public_path__ + "be1e54c7ba982d3e47f21b2ff7742270.png";